<search-bank-modal-tag>
  <style>
  .selected_item_text{
    display: inline-block;
    max-width: 100%;
    margin-top: 1px;
    margin-bottom: 1px;
    font-size: 1.5rem;
    font-weight: 500;
  }
  .bank_button{
    cursor: pointer;
    color: inherit;
    text-align: center;
    width: 100%;
    max-width: 100%;
    font-size: 14px;
    font-weight: 400;
    padding: 6px 12px;
    border-radius: 3px;
    background: white;
    border: 1px solid #e7eaec;
  }
  .form__group{
    margin-bottom: 15px;
  }
  .bank_modal_text { 
    margin-bottom: 5px;
    font-size: 1.5rem;
  }
  .bank_modal_table{
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }
  .bank_modal_table_items{
    padding: 8px;
    line-height: 1.42857143;
    font-size: 1.3rem;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }
  </style>

  <div class="modal js-modal" is="modal-base" is-open="{ props.isOpen }" on-before-show="{ onBeforeShow }">

    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>

    <div class="modal__content">

      <div class="modal__content_inner">

        <h3 class="modal_heading margin-spacing-3_bottom">
          銀行・支店検索
        </h3>

        <div class="modal__body" style="position: relative;">

            <div class="form__group" if={ state.mode=='bank_search' || state.mode== 'bank_result'}>
                <p class="bank_modal_text">銀行名の最初の文字をクリックしてください</p>
                <table class="bank_modal_table" cellspacing="1">
                    <tbody>
                    <tr>
                        <td><input type="button" class="bank_button" value="あ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="か" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="さ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="た" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="な" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="は" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ま" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="や" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ら" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="わ" onclick="{ searchBank }"></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="い" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="き" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="し" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ち" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="に" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ひ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="み" onclick="{ searchBank }"></td>
                        <td>&nbsp;</td>
                        <td><input type="button" class="bank_button" value="り" onclick="{ searchBank }"></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="う" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="く" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="す" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="つ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ぬ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ふ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="む" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ゆ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="る" onclick="{ searchBank }"></td>
                    <td></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="え" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="け" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="せ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="て" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ね" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="へ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="め" onclick="{ searchBank }"></td>
                        <td>&nbsp;</td>
                        <td><input type="button" class="bank_button" value="れ" onclick="{ searchBank }"></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="お" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="こ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="そ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="と" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="の" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ほ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="も" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="よ" onclick="{ searchBank }"></td>
                        <td><input type="button" class="bank_button" value="ろ" onclick="{ searchBank }"></td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="bank_result" style="max-height: 300px; overflow-y: scroll" if={ state.mode=='bank_result' }>
                <table class="bank_modal_table">
                <thead>
                    <tr>
                        <th class="bank_modal_table_items">銀行コード</th>
                        <th class="bank_modal_table_items">銀行名</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr each={ item in state.banks } >
                        <td class="bank_modal_table_items">{ item.bank_code }</td>
                        <td class="bank_modal_table_items">{ item.bank_name_kanji }</td>
                        <td class="bank_modal_table_items">
                          <input type="button" class="button button-secondary-mini" value="選択" onclick={e=>selectedBank(e,item)}>
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>

            <div class="form__group branch_selector" if={ state.mode == 'branch_search' || state.mode=='branch_result'}>
                <p class="bank_modal_text">銀行：{ state.bank.bank_name_kanji } [{ state.bank.bank_code }]</p>
                <p class="bank_modal_text">支店名の最初の文字をクリックしてください</p>
                <table class="bank_modal_table" cellspacing="1">
                    <tbody>
                    <tr>
                        <td><input type="button" class="bank_button" value="あ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="か" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="さ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="た" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="な" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="は" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ま" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="や" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ら" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="わ" onclick="{ searchBranch }"></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="い" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="き" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="し" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ち" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="に" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ひ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="み" onclick="{ searchBranch }"></td>
                        <td>&nbsp;</td>
                        <td><input type="button" class="bank_button" value="り" onclick="{ searchBranch }"></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="う" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="く" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="す" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="つ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ぬ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ふ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="む" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ゆ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="る" onclick="{ searchBranch }"></td>
                    <td></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="え" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="け" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="せ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="て" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ね" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="へ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="め" onclick="{ searchBranch }"></td>
                        <td>&nbsp;</td>
                        <td><input type="button" class="bank_button" value="れ" onclick="{ searchBranch }"></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><input type="button" class="bank_button" value="お" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="こ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="そ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="と" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="の" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ほ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="も" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="よ" onclick="{ searchBranch }"></td>
                        <td><input type="button" class="bank_button" value="ろ" onclick="{ searchBranch }"></td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="branch_result" style="max-height: 300px; overflow-y: scroll;" if={ state.mode=='branch_result' }>
              <table class="bank_modal_table">
                <thead>
                    <tr>
                        <th class="bank_modal_table_items">支店コード</th>
                        <th class="bank_modal_table_items">支店名</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr each={ item in state.branches }>
                        <td class="bank_modal_table_items">{ item.branch_code }</td>
                        <td class="bank_modal_table_items">{ item.branch_name_kanji }</td>
                        <td class="bank_modal_table_items">
                          <input type="button" class="button button-secondary-mini" value="選択" onclick={e=>selectedBranch(e,item) }>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
        </div>

      </div><!--/.modal__content_inner-->

      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div><!--modal__content-->


  </div>

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      state: {
        mode: 'bank_search',
        banks: [],
        branches: [],
        bank: {},
        branch: {}
      },
      onBeforeShow(){
        this.state = {
          mode: 'bank_search',
          banks: [],
          branches: [],
          bank: {},
          branch: {}
        };
        this.update();
      },
      selectedBank(e, item) {
        this.update({
          bank: item,
          mode: 'branch_search'
        });
      },
      selectedBranch(e, item) {
        this.props.onClose(e, this.state.bank, item);
      },
      searchBank(e) {
        this.props.api.request('bank-account', 'find-bank', {val: e.target.value})
        .then(data=> this.update({banks: data, mode: 'bank_result'}))
      },
      searchBranch(e) {
        this.props.api.request('bank-account', 'find-branch', {val: e.target.value, bank_code: this.state.bank.bank_code})
        .then(data=> this.update({branches: data, mode: 'branch_result'}))
      },
      onBeforeMount(){
      },
      onMounted(){
      }
    };
  </script>

</search-bank-modal-tag>
